import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import { InputAdornment, TextField, IconButton, TextFieldProps } from "@mui/material";

const PasswordHideShow = ({ hidden, onToggle }: { hidden: boolean; onToggle: () => void }) => (
    <IconButton aria-label="toggle password visibility" onClick={onToggle} edge="end" tabIndex={-1}>
        <FontAwesomeIcon icon={hidden ? faEyeSlash : faEye} size="sm" />
    </IconButton>
);

export interface PasswordFieldProps extends Omit<TextFieldProps, "variant" | "label" | "fullWidth" | "type"> {
    label?: string;
}

const PasswordField = React.forwardRef<HTMLDivElement, PasswordFieldProps>(
    ({ label, slotProps: slotPropsProp, ...props }, ref) => {
        const [showPassword, setShowPassword] = useState(false);

        const slotProps = {
            input: {
                endAdornment: (
                    <InputAdornment position="end">
                        <PasswordHideShow hidden={!showPassword} onToggle={() => setShowPassword(!showPassword)} />
                    </InputAdornment>
                ),
            },
            ...slotPropsProp,
        };

        return (
            <TextField
                ref={ref}
                variant="outlined"
                label={label ? <FormattedMessage id={label} /> : null}
                type={showPassword ? "text" : "password"}
                required
                fullWidth
                slotProps={slotProps}
                {...props}
            />
        );
    },
);

export default PasswordField;
